module.exports = __webpack_public_path__ + "img/logs.4f097519.jpg";